// Tiny shared helper for "who is this for / who is in this" chips.
//
// Renders a member's photo avatar (when uploaded) at chip-icon size,
// otherwise falls back to the emoji avatar. Without this the same
// chip rendered an `<span>{emoji}</span>` everywhere, so a family
// who'd taken the time to upload real photos still saw bald emojis
// in the event editor and Who's Free dialog. Used in CalendarSheet's
// "Who it's for" picker and the WhosFreeDialog Free / Busy lists.
//
// Sized for the 13–14px chip text with ~16–18px icon footprint —
// matches the chip's `text-base` emoji span exactly so swapping a
// photo in/out doesn't reflow the chip.
import React from "react";

export function MemberChipAvatar({ member, size = "md" }) {
  if (!member) return null;
  // 18px round photo lines up with `text-base` emoji glyphs in the
  // ff-chip surface. `sm` (15px) is for the smaller `ff-chip-sm`.
  const px = size === "sm" ? 15 : 18;
  if (member.avatar_image) {
    return (
      <img
        src={member.avatar_image}
        alt=""
        aria-hidden="true"
        loading="lazy"
        decoding="async"
        className="rounded-full object-cover flex-shrink-0"
        style={{ width: px, height: px }}
      />
    );
  }
  return <span className={size === "sm" ? "text-[13px]" : "text-base"}>{member.avatar_emoji}</span>;
}

export default MemberChipAvatar;
